<template>
  <div>
    <div v-if="!isRead" class="navigation-tabs">
      <b-overlay class="d-inline-block" :show="isbtnLoading" rounded opacity="0.6" spinner-small spinner-variant="primary">
        <b-button @click="CalculateAttendance()" class="d-flex" :disabled="isbtnLoading" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary">Hitung</b-button>
      </b-overlay>
    </div>
    <div class="tables">
        <BaseTable
           :fields="fields"
           :items="items"
           :loading="loading"
           :rows="pagination.total"
           :perPage="filter.size"
           :currentPage="filter.page"
           :handle-page-change="handlePageChange"
           :hideView="true"
           :hideUpdate="true"
           :hideDelete="true"
           :HideOptions="true"
        />
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import Ripple from "vue-ripple-directive";
import BaseTable from "@/components/BaseTable.vue";
import { BCard, BRow, BCol, BButton, BFormInput, BOverlay } from "bootstrap-vue";
import { AttendaceTabsServices } from '../../services/attendance.service';
import { successNotification, errorNotification } from "@/auth/utils";
import utility from '../../libs/utility'
import { CalculateSalaryServices } from '../../services/calculate-salary.service'
export default {
  name: "AtendanceForm",
  components: {
    BCard,
    BRow,
    BButton,
    BaseTable,
    BOverlay
  },
  directives: {
    Ripple,
  },
  props: {
    isRead: {
      type: Boolean
    }
  },
  data() {
    return {
      fields: [
        {
          key: "no",
          label: "No"
        },
        {
           key: "employeeName",
           label: "Nama"
        },
        {
          key: "sick",
          label: "Sakit"
        },
        {
          key: "leave",
          label: "Izin"
        },
        {
          key: "alfa",
          label: "Alfa"
        },
        {
          key: "attend",
          label: "Kehadiran"
        },
      ],
      items: [],
      loading: false,
      isbtnLoading: false,
      pagination: {
        total: 0
      },
      filter: {
        title: "",
        page: 1,
        size: 10
      },
    }
  },
  watch: {
    'filter.page': function () {
      this.GetAttendace();
    }
  },
  methods: {
    handlePageChange(value) {
      this.loading = true
      this.filter.page = value;
    },
    async GetAttendace() {0
      this.loading = true;
      let router  =  this.$route;
      window.console.log(router);
      let req = {
        page: this.filter.page,
        size: this.filter.size,
        payslipId: router.params.id
      };
      window.console.log(req);
      this.items = [];
      await AttendaceTabsServices.find(req)
        .then((result) => {
          if (result.code === "00") {
            window.console.log(result);
            result.data.content.forEach((items,index) => {
               items['no'] = index;
               this.items.push(items);
            });
            this.pagination.total  =  result.data.total;
          }
          this.loading  =  false;
        })
        .catch((e) => {
           this.loading  =  false;
           return errorNotification(this, "Oops!", e.message);
        });
    },
    async CalculateAttendance() {
      this.isbtnLoading = true;
      let router = this.$route;
      let req = {
        payslipId: router.params.id
      };
      await this.$http.post('/payslip/payslip-attendance/calculate',req)
        .then((result) => {
          window.console.log(result);
          if (result.data.code === "00") {
            successNotification(this,result.data.message);
            this.GetAttendace();
          } else {
            errorNotification(this,"Oops!",result.message);
          }
          this.isbtnLoading = false;
        })
        .catch((e) => {
          errorNotification(this, "Oops!", e.message);
          this.isbtnLoading = false;
        });
    },
  },
  mounted() {
    this.GetAttendace();
  }
}
</script>
